import React from 'react';
import { MENU_SCREEN_ROUTE, REVIEW_ORDER_SCREEN_ROUTE } from '../hooks/useRoutes';
import { useAppSelector } from '../app/hooks';
import ModalBackButton from './ModalBackButton';
import Text from './Text';
import history from '../history';
import getDeviceTypeMobile from '../selectors/getDeviceTypeMobile';
import combineStyles from '../utils/combineStyles';
import { CONTAINER_PROPERTIES } from '../utils/theme';
import getThemeLookup from '../selectors/getThemeLookup';

const OrderingWrapper = ({
  title,
  subtitle,
  children,
  bottomContainer,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  bottomContainer?: React.ReactNode;
}) => {
  const deviceTypeMobile = useAppSelector(getDeviceTypeMobile);
  const p = useAppSelector(getThemeLookup);

  return (
    <div
      className="position-relative"
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        paddingTop: 10,
        paddingBottom: 10,
      }}
    >
      <div>
        <div
          style={
            deviceTypeMobile
              ? combineStyles(
                  {
                    position: 'sticky',
                    top: 0,
                    padding: '1em 0',
                    zIndex: 99,
                  },
                  p('reviewOrderMobileHeader', CONTAINER_PROPERTIES),
                )
              : {}
          }
        >
          <div style={{ position: 'absolute', left: deviceTypeMobile ? 15 : 20 }}>
            <ModalBackButton
              onClick={() => history.push(MENU_SCREEN_ROUTE, { from: REVIEW_ORDER_SCREEN_ROUTE })}
            />
          </div>

          <div
            style={{
              flex: 1,
              flexDirection: 'row',
              textAlign: 'center',
              fontWeight: '500',
              margin: !deviceTypeMobile ? '1.5rem 0' : 0,
              height: '36px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Text value={title} themeKey="checkoutTitle" variant="h2" />
            {subtitle && <Text value={subtitle} themeKey="checkoutTitle" />}
          </div>
        </div>

        <div style={{ marginTop: 15 }}>{children}</div>
      </div>
      <div
        style={{
          marginTop: 'auto',
        }}
      >
        {bottomContainer}
      </div>
    </div>
  );
};

export default OrderingWrapper;
